import React, { createContext, useState, useEffect } from "react";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export const CartContext = createContext();

export function CartProvider({ children }) {
  const [cart, setCart] = useState(() => {
    const saved = localStorage.getItem("cart");
    return saved ? JSON.parse(saved) : [];
  });
  

  useEffect(() => {
    localStorage.setItem("cart", JSON.stringify(cart));
  }, [cart]);

  const showToast = (message) => {
    toast.success(message, {
      position: "top-left",
      rtl: true,
      autoClose: 2500,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      icon: '🔄',
      style: {
        background: '#E8F5E9', // light green
        color: '#1B5E20',      // dark green text
        borderRight: '4px solid #2E7D32'
      }
    });
  };

  const addToCart = (product) => {
    // Avoid side-effects inside setCart updater to prevent duplicate toasts in React 18 StrictMode
    const exists = cart.find((item) => item.id === product.id);
    const addQty = Number(product?.qty) > 0 ? Number(product.qty) : 1;

    if (exists) {
      setCart((prev) =>
        prev.map((item) =>
          item.id === product.id
            ? { ...item, qty: item.qty + addQty }
            : item
        )
      );
      showToast(`تم تحديث كمية ${product.name} في السلة`);
    } else {
      setCart((prev) => [...prev, { ...product, qty: addQty }]);
      showToast(`تمت إضافة ${product.name} إلى السلة`);
    }
  };

  const updateQuantity = (id, newQty) => {
    setCart((prev) =>
      prev.map((item) =>
        item.id === id ? { ...item, qty: Math.max(1, newQty) } : item
      )
    );
    
    const product = cart.find(item => item.id === id);
    if (product) {
      showToast(`تم تحديث كمية ${product.name} إلى ${newQty}`);
    }
  };

  const removeFromCart = (id, productName) => {
    setCart((prev) => prev.filter((i) => i.id !== id));
    showToast(`تمت إزالة ${productName} من السلة`);
  };

  const clearCart = () => {
    setCart([]);
    showToast("تم تفريغ السلة");
  };

  return (
    <CartContext.Provider value={{ cart, addToCart, removeFromCart, updateQuantity, clearCart }}>
      {children}
    </CartContext.Provider>
  );
}
